(() => {
  function initFrescoMobileMenu() {
    const root = document.getElementById('Details-menu-drawer-container');
    const drawer = root?.querySelector('.fresco-mobile-drawer');

    if (!root || !drawer) return;

    const applyDrawerState = () => {
      const isOpen = root.hasAttribute('open');

      drawer.style.setProperty('display', 'flex', 'important');
      drawer.style.setProperty('flex-direction', 'column', 'important');
      drawer.style.setProperty('transition', 'none', 'important');
      drawer.style.setProperty('transform', isOpen ? 'translateX(0)' : 'translateX(-100%)', 'important');
      drawer.style.setProperty('visibility', isOpen ? 'visible' : 'hidden', 'important');
      drawer.style.setProperty('opacity', isOpen ? '1' : '0', 'important');
    };

    const scheduleStateSync = () => {
      window.requestAnimationFrame(applyDrawerState);
      window.setTimeout(applyDrawerState, 80);
      window.setTimeout(applyDrawerState, 360);
    };

    new MutationObserver(applyDrawerState).observe(root, {
      attributes: true,
      attributeFilter: ['open'],
    });

    root.addEventListener('click', scheduleStateSync);
    window.addEventListener('pageshow', applyDrawerState);
    window.addEventListener('resize', applyDrawerState, { passive: true });

    applyDrawerState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFrescoMobileMenu, { once: true });
  } else {
    initFrescoMobileMenu();
  }
})();
